import accueil from './accueil';
import mescoordonnees from './mescoordonnees';
import prestations from './prestations';
import mesdocuments from './mesdocuments';
import mamessagerie from './mamessagerie';
import {FormattedMessage} from "react-intl";
import { IconCurrencyEuro } from '@tabler/icons-react';
import {
    IconUsers,         // For "AFFILIATIONS"
    IconSettings,      // For "ADMINISTRATION"
    IconAlertTriangle, // For "SINISTRES"
    IconShield,        // For "PREVENTELIS"
    IconReceiptEuro,   // For "DECOMPTES"
    IconHeart          // For "PRESTATIONS"
} from "@tabler/icons-react";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        accueil,
        mescoordonnees,
        // prestations,
        // ...Services(),
        mesdocuments,
        mamessagerie
    ]
};



const getDynamicMenus = (applications) => {

    const services = applications.map(app => {
        let icon = IconCurrencyEuro;
        switch (app.code) {
            case "AFFILIATIONS":
                icon = IconUsers;
                break;
            case "ADMINISTRATION":
                icon = IconSettings;
                break;
            case "SINISTRES":
                icon = IconAlertTriangle;
                break;
            case "DECOMPTES":
                icon = IconReceiptEuro;
                break;
            case "PREVENTELIS":
                icon = IconShield;
                break;
            case "PRESTATIONS":
                // icon = LocalHospitalIcon;
                break;
        }
        return {
            id: app.code,
            title: app.libelle,
            icon: icon,
            type: 'group',
            url: app.path,
            ...app
        }
    })

    return {
        items : [
            ...menuItems.items.slice(0, 2),
            ...services,
            ...menuItems.items.slice(2)
        ]
    }

}

export default menuItems;

export {
    getDynamicMenus
}
